
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Phone, Shield, Award } from 'lucide-react';

const RoofMaterialsHero = () => {
  return (
    <section 
      className="relative bg-gradient-to-r from-brand-charcoal-gray to-brand-charcoal-gray/80 text-white py-20 md:py-28 overflow-hidden"
      style={{
        backgroundImage: `url('/lovable-uploads/5f3827e5-0c99-43d2-80dc-04b1857cd807.png')`,
        backgroundSize: '200px 200px',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-brand-charcoal-gray/90"></div>
      
      <div className="relative container mx-auto px-4 z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-brand-trophy-gold drop-shadow-lg">
            Premium Roof Installations & Materials
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white max-w-3xl mx-auto drop-shadow-md">
            Expert installation of top-quality roofing materials backed by industry-leading warranties. 
            From asphalt shingles to metal roofing systems, we deliver lasting protection for your property.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link to="/contact">
              <Button size="lg" className="bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-white font-semibold px-8">
                Get Free Material Quote
              </Button>
            </Link>
            <Button size="lg" variant="outline" className="border-brand-trophy-gold text-brand-trophy-gold hover:bg-brand-trophy-gold/10 font-semibold px-8">
              <Phone className="mr-2 h-5 w-5" />
              Call (252) 371-2266
            </Button>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex flex-col items-center">
              <Shield className="h-12 w-12 text-brand-trophy-gold mb-3" />
              <h3 className="text-lg font-semibold mb-2">Premium Materials</h3>
              <p className="text-sm text-gray-300">GAF, Owens Corning, IKO, CertainTeed certified products</p>
            </div>
            <div className="flex flex-col items-center">
              <Award className="h-12 w-12 text-brand-trophy-gold mb-3" />
              <h3 className="text-lg font-semibold mb-2">Expert Installation</h3>
              <p className="text-sm text-gray-300">Certified technicians with 10+ years experience</p>
            </div>
            <div className="flex flex-col items-center">
              <Phone className="h-12 w-12 text-brand-trophy-gold mb-3" />
              <h3 className="text-lg font-semibold mb-2">Lifetime Warranties</h3>
              <p className="text-sm text-gray-300">Comprehensive coverage on materials and workmanship</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoofMaterialsHero;
